import {
    collection, query, where, limit, getDocs, addDoc, updateDoc, serverTimestamp, Timestamp,
} from 'firebase/firestore';
import { db } from './firebase';
import { toLocalPhone } from './CallHistory';

/**
 * Flutter admin app এর updateAdminSalary এর হুবহু React রূপ।
 *   admins (email মিলিয়ে) → salary ± amount, lastPaymentUpdateDate
 *   action_track_balance  → প্রতিটা বদলের রেকর্ড
 * Flutter এর মতোই কখনো throw করে না — { success, message, ... } ফেরত দেয়।
 */
export async function updateAdminSalary({ amount, actionName, isAddition, staffEmail }) {
    try {
        const snap = await getDocs(query(collection(db, 'admins'), where('email', '==', staffEmail), limit(1)));
        if (snap.empty) return { success: false, message: 'Admin not found' };

        const adminDoc = snap.docs[0];
        const currentSalary = Number(adminDoc.data().salary || 0);
        const newSalary = isAddition ? currentSalary + amount : currentSalary - amount;

        await updateDoc(adminDoc.ref, {
            salary: newSalary,
            lastPaymentUpdateDate: serverTimestamp(),
        });

        await addDoc(collection(db, 'action_track_balance'), {
            email: staffEmail,
            amount,
            action: actionName,
            type: isAddition ? 'Addition' : 'Deduction',
            previousSalary: currentSalary,
            newSalary,
            timestamp: serverTimestamp(),
            createdAt: Timestamp.now(),
        });

        return { success: true, message: 'Salary updated successfully', previousSalary: currentSalary, newSalary, amount, action: actionName };
    } catch (e) {
        console.error('updateAdminSalary failed:', e);
        return { success: false, message: `Error: ${e.message}` };
    }
}

/**
 * Flutter এর checkRecentAnsweredCall — আগে MicroSIP_Call_History দেখত, এখন কল সার্ভারের callRecords।
 * শেষ ২ দিনে ওই নাম্বারে একটা Answered (ধরা) কল থাকলে true।
 *   callRecords.timestamp = কল শুরুর সময় (Unix সেকেন্ড) — MicroSIP এর timestamp এর মতোই একক
 *   callRecords.answered  = true হলে কলটা ধরা হয়েছে
 * composite index না লাগার জন্য শুধু number দিয়ে query, বাকিটা এখানে ফিল্টার।
 * Firestore পড়তে ব্যর্থ হলে throw করে — যাতে ভুলে salary না কাটা যায়।
 */
export async function hasRecentAnsweredCall(phone, days = 2) {
    const local = toLocalPhone(phone);
    if (local.length < 10) return false;
    const since = Math.floor(Date.now() / 1000) - days * 24 * 60 * 60;
    const snap = await getDocs(query(collection(db, 'callRecords'), where('number', '==', local), limit(300)));
    return snap.docs.some((d) => {
        const c = d.data();
        const ts = Number(c.timestamp) || 0;
        return c.answered === true && ts >= since;
    });
}
